module.exports = __webpack_public_path__ + "img/ug513.206dc4c7.png";